import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { GlobalFormGroup } from '@app/services/formulario';
import { convertErrorsNz } from '@app/utiles/ng-zorro';

interface OptionRadioGroup {
  label: string;
  value: string;
}
@Component({ standalone: false, selector: 'app-form-reactive-radio-group',
  templateUrl: './reactive-radio-group.component.html',
  styleUrls: ['reactive-radio-group.component.scss']
})
export class FormReactiveRadioGroup<T> {
  @Input() label: string = '';
  @Input() labelClass: string = '';
  @Input() readonly: boolean = false;
  @Input() inputFormControl: GlobalFormGroup<T> = null;
  @Input() buttons: any[] = [];
  _optionsRadioGroup: OptionRadioGroup = { label: 'label', value: 'value' };
  @Input() set optionsRadioGroup(options: OptionRadioGroup) {
    this._optionsRadioGroup = { ...this._optionsRadioGroup, ...options };
  }
  readonly convertErrorsNz = convertErrorsNz;
  // Necesario para evitar el error de tipado para [formControl] (https://github.com/ngx-formly/ngx-formly/issues/2842)
  readonly asFormControl = (formControl: AbstractControl): FormControl => formControl as FormControl;
  trackByButton = (index: number, button: any): string | number => button?.[this._optionsRadioGroup.value] ?? index;
}
